import { render, staticRenderFns } from "./ArticlesOfAgreement.vue?vue&type=template&id=f34fc770&scoped=true&"
import script from "./ArticlesOfAgreement.vue?vue&type=script&lang=js&"
export * from "./ArticlesOfAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesOfAgreement.vue?vue&type=style&index=0&id=f34fc770&lang=scss&rel=text%2Fcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34fc770",
  null
  
)

export default component.exports